import React from 'react';
import { IconProps } from './types';

const Share: React.FC<IconProps> = ({
  className,
  color = '#181B32',
  size = 32,
  ignoreColor,
}) => (
  <svg className={className} viewBox="0 0 22 22" width={size} height={1 * size}>
    <path
      d="M18.071 0a3.94 3.94 0 0 0-3.928 3.929c0 .256.026.507.074.75L7.17 8.79a3.93 3.93 0 0 0-3.241-1.719A3.94 3.94 0 0 0 0 11a3.94 3.94 0 0 0 3.929 3.928 3.93 3.93 0 0 0 3.24-1.718l7.048 4.111a3.9 3.9 0 0 0-.074.75A3.94 3.94 0 0 0 18.07 22 3.94 3.94 0 0 0 22 18.071a3.94 3.94 0 0 0-3.929-3.928 3.93 3.93 0 0 0-3.24 1.719L7.782 11.75a3.9 3.9 0 0 0 0-1.5l7.047-4.112a3.93 3.93 0 0 0 3.241 1.72A3.94 3.94 0 0 0 22 3.927 3.94 3.94 0 0 0 18.071 0zm0 1.571A2.345 2.345 0 0 1 20.43 3.93a2.345 2.345 0 0 1-2.358 2.357 2.345 2.345 0 0 1-2.357-2.357 2.345 2.345 0 0 1 2.357-2.358zM3.93 8.643A2.345 2.345 0 0 1 6.286 11a2.345 2.345 0 0 1-2.357 2.357A2.345 2.345 0 0 1 1.57 11 2.345 2.345 0 0 1 3.93 8.643zm14.142 7.071a2.345 2.345 0 0 1 2.358 2.357 2.345 2.345 0 0 1-2.358 2.358 2.345 2.345 0 0 1-2.357-2.358 2.345 2.345 0 0 1 2.357-2.357z"
      fill={!ignoreColor ? color : undefined}
    />
  </svg>
);

export default Share;
